(function ($) {
  Drupal.behaviors.siwertellGallery = {
    attach: function (context) {
      $(".gallery a").magnificPopup({
        type: "image",
        gallery: {
          enabled: true,
          tCounter: "",
        },
        image: {
          markup:
            '<div class="mfp-figure">' +
            '<div class="mfp-close"></div>' +
            '<div class="mfp-img"></div>' +
            '<div class="mfp-bottom-bar">' +
            '<div class="mfp-title"></div>' +
            "</div>" +
            "</div>",
          cursor: null,
          titleSrc: function (item) {
            var text = "";
            if (item.el.find("img").attr("title") != null) {
              text = "<p>" + item.el.find("img").attr("title") + "</p>";
            }
            return text;
          },
        },
      });
    }
  }
})(jQuery);